'use memo'

import React from 'react'
import { ShareAltOutlined } from '@ant-design/icons'
import { ScrollSpyLayout } from 'src/components/ScrollSpyLayout'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { TextField, FieldRow } from '../FormikField'

const SocialProfilesSection: React.FC = () => (
  <ScrollSpyLayout.Section
    id='socialProfiles'
    title={capitalizeWords('Social Profiles')}
    icon={<ShareAltOutlined />}
  >
    <FieldRow>
      <TextField
        name='facebook'
        label='Facebook'
        placeholder='facebook.com/ username'
      />
      <TextField
        name='instagram'
        label='Instagram'
        placeholder='instagram.com/ username'
      />
    </FieldRow>
    <FieldRow>
      <TextField
        name='tiktok'
        label='TikTok'
        placeholder='tiktok.com/@ username'
      />
      <TextField
        name='youtube'
        label='YouTube'
        placeholder='youtube.com/ username'
      />
    </FieldRow>
  </ScrollSpyLayout.Section>
)

export default SocialProfilesSection
